import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import {
  type TonTransactionDataType,
  type TransactionType,
} from '@/common/types/userType';
import { StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import bagPng from '/img/icons/bag.png';
import bagWebp from '/img/icons/bag.webp';
import targetPng from '/img/icons/target.png';
import targetWebp from '/img/icons/target.webp';
import walletPng from '/img/icons/wallet.png';
import walletWebp from '/img/icons/wallet.webp';
import cupPng from '/img/icons/сup.png';
import cupWebp from '/img/icons/сup.webp';

const EarningsItem: FC<TonTransactionDataType> = ({ type, date, amount }) => {
  const { t } = useTranslation();

  const dateString = new Date(date);

  const formattedDate = dateString.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  const texts: Record<TransactionType, string> = {
    partners: 'Partners',
    arena: 'Arena',
    challenges: 'Challenges',
    withdraw: 'Wallet / Withdraw',
    bonus: 'Bonus',
    buy_arena_offer: 'Arena Offer',
  };

  const images: Record<TransactionType, { png: string; webp: string }> = {
    challenges: {
      png: targetPng,
      webp: targetWebp,
    },
    arena: {
      png: cupPng,
      webp: cupWebp,
    },
    partners: {
      png: bagPng,
      webp: bagWebp,
    },
    withdraw: {
      png: walletPng,
      webp: walletWebp,
    },
    bonus: {
      png: targetPng,
      webp: targetWebp,
    },
    buy_arena_offer: {
      png: cupPng,
      webp: cupWebp,
    },
  };

  const image = images[type];
  const text = texts[type];

  return (
    <div className={css.earningsItem}>
      <div className="flex items-center gap-2 min-w-0">
        {image && (
          <Picture
            className="w-6 h-6 shrink-0"
            img={image.png}
            webp={image.webp}
            alt={type}
          />
        )}
        <StringSmall
          weight="medium"
          className="text-nowrap whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {t(text)}
        </StringSmall>
      </div>
      <StringSmall
        weight="medium"
        className="!text-white/60 text-nowrap whitespace-nowrap overflow-hidden text-ellipsis"
      >
        {formattedDate}
      </StringSmall>
      <StringSmall
        weight="medium"
        className={cn('text-right', amount > 0 ? css.positive : css.negative)}
      >
        {amount > 0 ? `+${amount}` : amount}
      </StringSmall>
    </div>
  );
};

export { EarningsItem };
